/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Existing_AgentsInputs */

const en_existing_agents = /** @type {(inputs: Existing_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Works with Claude Code · Cursor · Codex · OpenCode · Antigravity · Pi`)
};

const id_existing_agents = /** @type {(inputs: Existing_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bisa dengan Claude Code · Cursor · Codex · OpenCode · Antigravity · Pi`)
};

/**
* | output |
* | --- |
* | "Works with Claude Code · Cursor · Codex · OpenCode · Antigravity · Pi" |
*
* @param {Existing_AgentsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const existing_agents = /** @type {((inputs?: Existing_AgentsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Existing_AgentsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_existing_agents(inputs)
	return en_existing_agents(inputs)
});